import { render, staticRenderFns } from "./ComplaintsReport.vue?vue&type=template&id=489544fe&scoped=true&"
import script from "./ComplaintsReport.vue?vue&type=script&lang=js&"
export * from "./ComplaintsReport.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsReport.vue?vue&type=style&index=0&id=489544fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489544fe",
  null
  
)

export default component.exports